import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import {
  homeContentInnerSx,
  homeHeroGreetingSx,
  homeHeroWelcomeSx,
  providerShellHeroShellSx,
  providerShellHeroSx,
} from '@/features/home/styles/homeStyles'
import Typography from '@mui/material/Typography'
import {
  notificationsCardSx,
  notificationsContentInnerSx,
  notificationsContentShellSx,
  notificationsPageRootSx,
  notificationsPageSubtitleSx,
  notificationsPageTitleSx,
} from '../styles/notificationsPageStyles'

export function NotificationsPageSkeleton() {
  return (
    <Box sx={notificationsPageRootSx} data-testid="provider-notifications-page-skeleton" aria-busy>
      <Box sx={providerShellHeroSx}>
        <Box sx={providerShellHeroShellSx}>
          <Box sx={homeContentInnerSx}>
            <Skeleton variant="text" sx={{ ...homeHeroGreetingSx, width: 280 }} />
            <Skeleton variant="text" sx={{ ...homeHeroWelcomeSx, width: 200 }} />
          </Box>
        </Box>
      </Box>
      <Box sx={notificationsContentShellSx}>
        <Box sx={notificationsContentInnerSx}>
          <Typography component="div" sx={notificationsPageTitleSx}>
            <Skeleton width={180} />
          </Typography>
          <Typography component="div" sx={notificationsPageSubtitleSx}>
            <Skeleton width={260} />
          </Typography>
          <Box sx={notificationsCardSx}>
            {Array.from({ length: 4 }, (_, i) => (
              <Skeleton key={i} variant="rounded" height={88} sx={{ m: 2 }} />
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
